function drawertoggle(){
    document.querySelector('.mdl-layout').MaterialLayout.drawerToggleHandler_();
      }

export default drawertoggle;